import React, { useEffect, useRef, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { jdsSelectProps } from '../../../../components/jds/selectProps';
import { PlansAPI } from '../../../../api/payments/plans/api';

export function PlanSelect({
  plans,
  plansLoading,
  value,
  onChange,
  error,
}) {
  const [extraOption, setExtraOption] = useState(null);

  const debounceRef = useRef(null);

  const loadOptions = (inputValue) =>
    new Promise((resolve) => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(async () => {
        try {
          const response = await PlansAPI.list({ name: inputValue });
          resolve(response.data.content || []);
        } catch (err) {
          resolve([]);
        }
      }, 400); // ms de espera após parar de digitar
    });

  // O plano selecionado pode estar fora da primeira página de resultados
  // (limit=100) buscada pelo componente pai; busca-o individualmente nesse
  // caso, sem alterar a lista compartilhada `plans`.
  useEffect(() => {
    if (plansLoading || !value) return;
    if (plans.some((option) => option.id === value)) {
      setExtraOption(null);
      return;
    }
    PlansAPI.get(value)
      .then((response) => setExtraOption(response.data))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, plansLoading, plans]);

  const options =
    extraOption && !plans.some((option) => option.id === extraOption.id)
      ? [...plans, extraOption]
      : plans;

  return (
    <div className="form-group mb-0">
      <label>Selecione o plano</label>
      <AsyncSelect
        name="planId"
        isSearchable
        isClearable
        defaultOptions={options}
        placeholder="Buscar..."
        noOptionsMessage={() => 'Nenhum resultado encontrado'}
        loadOptions={loadOptions}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        value={options.find((option) => option.id === value) || null}
        onChange={(option) => onChange(option ? option.id : '')}
        {...jdsSelectProps}
      />
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
}
